<template>
    <el-dialog 
        :visible.sync="visible" 
        width="90%" 
        custom-class="contact-dialog"
        :before-close="handleClose">
        <div class="contact-content">
            <!-- 上方信息 -->
            <div class="top-info">
                <div class="slogan">让渠道更易搜 让合作更放心</div>
                <div class="contact-box">
                    <div class="phone-number">13332888870</div>
                    <div class="phone-number">13288810072</div>
                </div>
            </div>
            
            <!-- 下方二维码 -->
            <div class="bottom-qrcode">
                <img :src="qrcodeImage" alt="二维码" class="qrcode-img">
                <div class="qrcode-text">扫码入驻&nbsp查看更多</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ContactDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        qrcodeImage: {
            type: String,
            default: require('../assets/images/qrcode.jpg')
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false);
        }
    }
}
</script>

<style lang="less" scoped>
.contact-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 20px;
}

.top-info {
    width: 100%;
    max-width: 600px;
    text-align: center;
    
    .slogan {
        font-size: 18px;
        color: #333;
        margin-bottom: 20px;
        font-weight: 500;
    }
    
    .contact-box {
        background-color: #fff7f4;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
 
        
        .phone-number {
            font-size: 16px;
            color: #FF6600;
            margin: 5px 0;
            font-weight: 500;
        }
    }
}

.bottom-qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-top:15px;
    .qrcode-img {
        width: 250px;
        height: 250px;
        border-radius: 8px;
    }
    
    .qrcode-text {
        font-size: 16px;
        color: #666;
        text-align: center;
    }
}

@media (max-width: 767px) {
    .contact-content {
        gap: 20px;
        padding: 15px;
    }
    
    .top-info {
        .slogan {
            font-size: 16px;
            margin-bottom: 15px;
        }
        
        .contact-box {
            padding: 15px;
            width: 80%;
            margin:auto;
            
            .phone-number {
                font-size: 14px;
            }
        }
    }
    
    .bottom-qrcode {
        .qrcode-img {
            width: 150px;
            height: 150px;
        }
        
        .qrcode-text {
            font-size: 14px;
        }
    }
}
</style> 